import styled from "styled-components";

export const PlaceholderWrapper = styled.div`
  padding: 10px 16px;
  border: 1px solid #dcdcdc;
  border-radius: 999px;
  background-color: #f9f9f9;
  color: #dcdcdc;
  font-weight: 700;
  font-size: 14px;
  width: 100%;
  min-height: 20px;
  margin-bottom: 4px;
  display: inline-block;
  margin-right: 12px;
  margin-top: 4px;
`;

export const PlaceholderBar = styled.span`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  display: block;
  height: 14px;
  border-radius: 4px;
  width: 100%;
`;
